import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/gv-logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/back-arr.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/reviewed-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/facebook-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/instagram-icon.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/pinterest.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/portal/public/images/icons/social/twitter-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Article/common/ArticleOptions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Categories/category-article-list/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/libs/modules/src/shared/Product/views/article-product/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
